import React, { Component } from 'react';
import { MnemoCallout } from './MnemoCallout';
import ReactHtmlParser from 'react-html-parser';


export class SupportoTecnicoLive extends Component {

    getEmail(courseCode) {

        let email = '';

        if (courseCode.includes('SASUM')) {
            email = 'lezionisostegno@formazionedocenti.it';
        } else if (courseCode.includes('60CFU') || courseCode.includes('60ALL')) {
            email = 'lezioni60cfu@formazionedocenti.it';
        } else if (courseCode.includes('UM30ALL') || courseCode.includes('UMALL') || courseCode.includes('UNT30ALL') || courseCode.includes('UNTALL') || courseCode.includes('RCALL') || courseCode.includes('RC30ALL')) {
            email = 'lezioni60cfu@formazionedocenti.it';
        } else if (courseCode.includes('30CFU') || courseCode.includes('30ALL')) {
            email = 'lezioni30cfu@formazionedocenti.it';
        } else if (courseCode.includes('ART13')) {
            email = 'lezioni30cfu@formazionedocenti.it';
        }  else if (courseCode.includes('TFAPA') || courseCode.includes('TFAVE')) {
            email = 'lezionisostegno@formazionedocenti.it';
        }

        return email;
    }

    render() {

        const { courseCode } = this.props;
        let txt = '';

        const email = this.getEmail(courseCode)


        txt = `In caso di problemi per l'accesso alle lezioni telematiche in modalità sincrona invia un messaggio email a <a href="mailto:${email}">${email}</a>.`;

        return (
            <>
                <div className="my-2">
                    <MnemoCallout>
                        {ReactHtmlParser(txt)}
                    </MnemoCallout>
                </div>
            </>
        );
    }
}